module.exports = __webpack_public_path__ + "img/3화_18.d0806cf8.png";